<template>
  <thead class="base-table-header">
    <slot />
  </thead>
</template>

<script>
export default {
  name: "BaseTableHeader",
};
</script>

<style lang="scss">
@import "./base-table-header.scss";
</style>
